import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAnalyticsPlansEmployeesInsightPostObjectivesIndexResponseTypes } from "~/domains";

type RequestDataType = {
  employeeId: string;
  page?: number;
};

const request = async ({
  employeeId,
  page = 1,
}: RequestDataType): Promise<ApisAnalyticsPlansEmployeesInsightPostObjectivesIndexResponseTypes> => {
  const response =
    await new ApiClient().get<ApisAnalyticsPlansEmployeesInsightPostObjectivesIndexResponseTypes>(
      `/api/analytics_plans/employees/${employeeId}/insight_post_objectives`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  employeeId: string;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisAnalyticsPlansEmployeesInsightPostObjectivesIndex = ({
  employeeId,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApisAnalyticsPlansEmployeesInsightPostObjectivesIndexResponseTypes> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisAnalyticsPlansEmployeesInsightPostObjectivesIndex", employeeId],
    ({ pageParam }) => {
      return request({ employeeId, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
